module.exports = __webpack_public_path__ + "static/media/m-fintech-img.c0f25e58.png";